import React, { useCallback, useEffect, useState } from 'react';
import { Box, Input, Text } from '@cko/primitives';
import { debounce } from '@cko/primitives';
import { MicroFrontendConfig } from '@cko/dashboard-shared';

type MFEConfigEditorProps = {
  name: string;
  value: MicroFrontendConfig;
  onChange: (value: MicroFrontendConfig) => void;
  valueOverridden?: boolean;
};

export const MFEConfigEditor = (props: MFEConfigEditorProps) => {
  const { name, value, onChange, valueOverridden } = props;
  const [updatedConfig, setUpdatedConfig] = useState<MicroFrontendConfig>(value);

  useEffect(() => {
    setUpdatedConfig(value);
  }, [value]);

  const debouncedUpdate = useCallback(
    debounce((newConfig: MicroFrontendConfig) => onChange(newConfig), 250),
    [onChange],
  );

  const updateEntryPoint = useCallback(
    (entryPoint: string) => {
      const newVal = { ...updatedConfig, entry_point: entryPoint };
      setUpdatedConfig(newVal);
      debouncedUpdate(newVal);
    },
    [setUpdatedConfig, updatedConfig, debouncedUpdate],
  );

  const updateConfigString = useCallback(
    (config: string) => {
      const newVal = { ...updatedConfig, config };
      setUpdatedConfig(newVal);
      debouncedUpdate(newVal);
    },
    [setUpdatedConfig, updatedConfig],
  );
  return (
    <div>
      <h4>{name}</h4>
      <Box style={{ display: 'grid', gap: '16px', gridTemplateColumns: 'repeat(2, 1fr)' }}>
        <Input
          label="Remote Entry"
          isRequired
          onChange={(e) => updateEntryPoint(e.target.value)}
          placeholder="Remote Entry URL"
          value={updatedConfig.entry_point}
        />
        <Input
          label="Config"
          isRequired
          onChange={(e) => updateConfigString(e.target.value)}
          placeholder="Config URL"
          value={updatedConfig.config || ''}
        />
      </Box>
      {valueOverridden && (
        <Text style={{ font: 'var(--helper-sm)', color: 'var(--base-text-bad)' }}>
          Value Overridden
        </Text>
      )}
    </div>
  );
};
